import { render, staticRenderFns } from "./CreateDataAnalysis.vue?vue&type=template&id=58af7c38&scoped=true"
import script from "./CreateDataAnalysis.vue?vue&type=script&lang=js"
export * from "./CreateDataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./CreateDataAnalysis.vue?vue&type=style&index=0&id=58af7c38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af7c38",
  null
  
)

export default component.exports